// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1KChc","productName":"Table_productName__1ZTOF"};